import PropTypes from 'prop-types';
import React from 'react';
import RenderRepoCard from './Card/RenderRepoCard';
import { StyledCardContainer } from './styles';

export default function RenderRepo({ repo }) {
  return (
    <>
      <StyledCardContainer>
        <RenderRepoCard cardData={repo} type="list" />
      </StyledCardContainer>
    </>
  );
}

RenderRepo.propTypes = {
  repo: PropTypes.oneOfType([PropTypes.object]).isRequired,
};
